import React from "react";
import { motion } from "framer-motion";
import { Store, Shirt, Sparkles, Scissors, Dumbbell, Coffee } from "lucide-react";
import { SECTORS } from "../data/content";

const ICONS = { Store, Shirt, Sparkles, Scissors, Dumbbell, Coffee };

export const Sectors = () => {
  return (
    <section id="settori" className="py-20 sm:py-28 bg-[#F9FAFB]" data-testid="sectors-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-2xl">
          <span className="text-sm font-bold uppercase tracking-[0.2em] text-brand">Idee per settore</span>
          <h2 className="mt-3 font-heading text-3xl sm:text-4xl font-bold tracking-tight text-brand-deep">
            Strategie su misura per la tua attività
          </h2>
          <p className="mt-4 font-body text-base sm:text-lg text-ink leading-relaxed">
            Qualunque sia il tuo settore, ecco come sfruttare PushApp al meglio.
            Spunti pratici da adattare al tuo piano mensile.
          </p>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {SECTORS.map((s, i) => {
            const Icon = ICONS[s.icon];
            return (
              <motion.div
                key={s.name}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
                className="group overflow-hidden rounded-3xl bg-white border border-gray-100 shadow-sm transition-all duration-300 hover:-translate-y-1.5 hover:shadow-xl hover:shadow-brand/5"
                data-testid={`sector-card-${i}`}
              >
                <div className="relative h-44 overflow-hidden">
                  <img
                    src={s.image}
                    alt={s.name}
                    loading="lazy"
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-brand-deep/40 to-transparent" />
                  <span className="absolute bottom-3 left-3 inline-flex h-11 w-11 items-center justify-center rounded-2xl bg-white text-brand shadow-lg">
                    <Icon size={22} strokeWidth={2.5} />
                  </span>
                </div>
                <div className="p-6">
                  <h3 className="font-heading text-xl font-semibold text-brand-deep">{s.name}</h3>
                  <p className="mt-2 font-body text-ink leading-relaxed">{s.text}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
